import { emojis } from './constants';

/**
 * Debounce function
 * This function takes a callback function and a delay timer as parameters.
 * It returns a new function that will execute the callback only after the delay time has passed since the last call.
 * It uses a timer variable to keep track of the last call time and clear any pending calls.
 *
 * @param {Function} func
 * @param {Number} delay
 */
function debounce(func, delay = 250) {
  let timer;
  return function (...args) {
    const context = this;
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}

/**
 * Throttle function
 * This function takes a callback function and a limit time as parameters.
 * It returns a new function that will execute the callback at most once every limit time.
 * It uses a flag variable to indicate whether the callback can be called or not.
 *
 * @param {Function} func
 * @param {Number} limit
 */
function throttle(func, limit = 250) {
  let flag = true;
  return function (...args) {
    const context = this;
    if (flag) {
      func.apply(context, args);
      flag = false;
      setTimeout(() => {
        flag = true;
      }, limit);
    }
  };
}

/**
 * Remove the hash sign of assigned text of element
 *
 * @param {Element} element
 */
const trimHash = (element) => {
  element.textContent = element.textContent.replace(/^#/, '');
};

/** Remove the emoji of assigned text of element
 *
 * @param {Element} element
 */
const trimEmoji = (element) => {
  const regex = new RegExp(`^${emojis.join('|')}`);
  if (regex.test(element.textContent)) {
    element.textContent = element.textContent.replace(regex, '');
  }
};

/** Check filter condition
 *
 * @param {DOMTokenList} classes
 * @param {Array} conditions
 * @returns {Boolean}
 */
const checkFilterCondition = (classes, conditions) => {
  const tagClasses = Array.from(classes).filter((item) =>
    item.startsWith('tag-')
  );
  const trimPrefixTagClasses = tagClasses.map((item) =>
    item.replace('tag-', '')
  );
  if (trimPrefixTagClasses.length) {
    return trimPrefixTagClasses.some((item) => conditions.includes(item));
  } else {
    return false;
  }
};

export { debounce, throttle, trimHash, trimEmoji, checkFilterCondition };
